import { ValidateCheckoutResponse } from "@ssc-booking/api-contracts"
import { priceResponse } from "../../../test-support/common"
import { cruiseCode } from "./cruisecode"

const validatedPrice = priceResponse(cruiseCode, "CV", { depositPercentage: 25, totalAmount: 11600 })
export default ValidateCheckoutResponse.build({
    suitePayment: validatedPrice.suitePayment,
    validatedPrice,
    flowType: "ECommerce",
})
